import Vue from 'vue'
import Vuex, { Store, StoreOptions } from 'vuex'

import appState, { ApplicationState } from './modules/app-state-module'
import chatRoomNotification, { ChatRoomNotificationState } from './modules/chat-room-notification-module'
import chatRoomController, { ChatRoomControllerState } from './modules/chatroom-controller-module'
// import channelRooms, { ChannelRoomsState } from './modules/channel-rooms-module'
// import chatRoomLastMessage, { ChatRoomLastMessage, ChatRoomLastMessageState } from './modules/chat-room-last-message-module'

Vue.use(Vuex)

// const debug = process.env.NODE_ENV !== 'production'

export interface MessengerState {
  appState: ApplicationState
  chatRoomController: ChatRoomControllerState
  chatRoomNotification: ChatRoomNotificationState
  // channelRooms: ChannelRoomsState
  // chatRoomLastMessage: ChatRoomLastMessage
}

const options: StoreOptions<MessengerState> = {
  modules: {
    appState,
    chatRoomController,
    chatRoomNotification,
    // channelRooms,
    // chatRoomLastMessage,
  },
  // ,
  // plugins: [createPersistedState()]
}

export type MessengerVuex = Store<MessengerState>

export function createMessengerVuex () {
  return new Store(options)
}

export * from './modules/app-state-module'
export * from './modules/chatroom-module'
export * from './modules/chatroom-controller-module'
// export * from './modules/channel-rooms-module'
// export * from './modules/chat-room-last-message-module'